import { type DocumentReference } from './adaptor';

export function getFirestoreLink(
  projectId: string,
  ref: DocumentReference<unknown>
): string {
  return `https://console.cloud.google.com/firestore/databases/-default-/data/panel/${ref.path}?project=${projectId}`;
}
